import { mapMutations } from 'vuex';
import api from '@/api';

export default {
  methods: {
    ...mapMutations(['setPrintContent']),

    async print(id) {
      const query = { $render: true };

      try {
        const study = await api.service('study').get(id, { query });
        this.setPrintContent(study);
      } catch (e) {
        throw e;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/study-print.js